"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var redux_devtools_extension_1 = require("redux-devtools-extension");
// Actions
exports.TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
exports.toggleSidebar = function () {
    return { type: exports.TOGGLE_SIDEBAR };
};
// Reducer
exports.reducer = function (state, action) {
    switch (action.type) {
        case exports.TOGGLE_SIDEBAR:
            return Object.assign({}, state, { isSidebarVisible: !state.isSidebarVisible });
        default:
            return state;
    }
};
// Store
exports.initialState = { isSidebarVisible: false };
exports.store = redux_1.createStore(exports.reducer, exports.initialState, redux_devtools_extension_1.devToolsEnhancer({}));


// WEBPACK FOOTER //
// ./~/babel-loader/lib?{"presets":["babel-preset-env"],"plugins":["/opt/build/repo/~/gatsby/dist/utils/babel-plugin-extract-graphql.js"]}!./~/ts-loader!./src/store.ts